import React from 'react';
import './index.scss';

const SectionHeader = ({ eyebrow, title, description }) => (
    <div className='section-header'>
        {eyebrow && <div className='section-header__eyebrow'>{eyebrow}</div>}
        <div className='section-header__title'>{title}</div>
        {description && <div className='section-header__description'>{description}</div>}
    </div>
);

export default SectionHeader;
